// extracted by mini-css-extract-plugin
export default {"price":"k0-z","onSale":"l0-z","msrpLabelPrice":"m0-z","originalPrice":"n0-z","msrpLabel":"o0-z","percentOff":"p0-z"};